import { combineReducers } from 'redux';

import sessionReducer from './sessionReducer';
import payserverReducer from './payserverReducer';

const rootReducer = combineReducers({
  session: sessionReducer,
  payserver: payserverReducer,
});

export default rootReducer;
